import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'

const ChartTableToggleMenu = BootslideMenu.extend({

	/**
	 * @type ChartDesigner
	 */
	model: null,

	menu: function () {
		let options = []

		options.push({
			type: 'toggle',
			label: 'charts.chart.settingType.chartTable.show',
			contentView: BootslideMenu.ToggleProperty.extend({
				property: { label: 'charts.chart.settingType.chartTable.show', name: 'chartTable' }
			})
		})

		return {
			label: i18n.get('charts.chart.settingType.chartTable'),
			target: options,
			width: 200
		}
	}
})

export default ChartTableToggleMenu
ChartTableToggleMenu.__filename__ = 'charts/edit/chart-table-toggle-menu.js'
